/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from "react";
import {
    Card
} from "@material-tailwind/react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import FetchVerificationData from "./data/tenantVerificationTableData";

export function TenantVerification() {
    const [refresh, setRefresh] = useState(false);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSuccess = () => {
        setSnackbarOpen(true);
        setRefresh(!refresh);
      };
   
    return (
        <DashboardLayout>
            <DashboardNavbar absolute isMini />
            <MDBox pt={8} pb={6} px={2}>
                <Grid container spacing={12}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Verification Form Details
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={3}>
                                <FetchVerificationData refresh={refresh} />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default TenantVerification;